import { useState } from 'react';
import VitrineNav from './VitrineNav';
import './LandingPage.css';

const FAQ_ITEMS = [
  {
    // ⚠️ PHRASE AJOUTÉE EN FIN DE RÉPONSE LE 13/09/2026, LE RESTE INCHANGÉ.
    //    « 48 h à 5 jours » ne vaut que pour un pays dont le référentiel EXISTE —
    //    aujourd'hui le Togo seul. Annoncer ce délai à un prospect camerounais,
    //    c'est promettre une mise en service qui suppose un référentiel national
    //    encore à établir.
    q: 'Combien de temps pour démarrer ?',
    r: 'La mise en service de GSS-360 prend entre 48\u202Fh et 5 jours ouvrés selon la taille de votre société. Nous importons vos données agents et sites existants, configurons votre espace et formons votre équipe administrative. Vous êtes opérationnels rapidement, sans perturber votre activité terrain. Ces délais valent pour un pays déjà couvert. Pour un premier déploiement dans un nouveau pays, le délai intègre l\'établissement du référentiel national et figure dans votre devis.',
  },
  {
    q: 'Mes données sont-elles sécurisées ?',
    r: 'Oui. Vos données sont hébergées sur des serveurs sécurisés, isolées de celles des autres clients (architecture multi-tenant), et sauvegardées automatiquement. Aucun autre client ne peut accéder à vos informations. En tant qu\'éditeur, nous n\'avons pas accès à vos données opérationnelles sans votre autorisation explicite.',
  },
  {
    // ⚠️ RÉÉCRITE LE 13/09/2026. L'ancienne promettait « vous passez au pack
    //    supérieur AU PRORATA du mois en cours ». Le code n'a AUCUN prorata de
    //    changement de pack : `resoudreOffre()` lit le code d'offre STOCKÉ sur
    //    l'abonnement et ne le recalcule jamais depuis l'effectif. Le seul prorata
    //    du produit est celui de la paie, sans rapport.
    //    ➡️ La page s'aligne sur le code (arbitrage de Dom). La bascule automatique
    //       de tranche est un chantier à part : tant qu'il n'existe pas, on ne
    //       l'annonce pas.
    q: 'Puis-je changer de pack en cours d\'abonnement ?',
    r: 'Oui, à tout moment. Vous nous en faites la demande, le nouveau tarif s\'applique à la période de facturation suivante. Rien ne change sur votre facture sans votre accord.',
  },
  {
    // ⚠️ CORRIGÉE LE 13/09/2026 — ELLE PROMETTAIT PLUS QUE CE QUE LE MOTEUR
    //    APPELLE. L'ancienne disait « l'abonnement annuel est disponible avec
    //    2 MOIS OFFERTS » : deux mois gratuits, sans réserve. La règle arrêtée
    //    est autre — dix mois réglés d'avance couvrent l'effectif DE
    //    SOUSCRIPTION, et tout dépassement produit un complément qui reste dû.
    //    Un client qui embauche en cours d'année paie donc plus que « dix mois ».
    // ⚠️ ET LA PHRASE ÉTAIT VENDUE SANS AUCUN CODE DERRIÈRE : mesuré le 13/09,
    //    rien n'implémentait le paiement annuel. Même famille que le portail
    //    client (file 15d) — une promesse tarifaire sans contrepartie. Le lot du
    //    jour construit le mécanisme ET aligne la phrase sur lui.
    q: 'Y a-t-il un engagement minimum ?',
    // ⓘ CONTRAINTE MESURÉE AVANT D'ÉCRIRE : `.vt-faq-answer-wrap` porte
    //   `overflow: hidden` et un `maxHeight: 300px` en dur (280 px utiles). À
    //   397 caractères la réponse tenait sur 265 px — 15 px de marge, trop juste
    //   pour un conteneur qui coupe en silence. Resserrée à 303 caractères :
    //   ~9 lignes × 22,1 px = 199 px, 29 % de marge, les quatre faits conservés.
    r: 'Non. GSS-360 fonctionne sans engagement de durée : vous payez mois par mois. '
      + 'L\'abonnement annuel est aussi possible — vous réglez dix mois d\'avance pour douze mois. '
      + 'Cette redevance couvre l\'effectif de souscription ; au-delà, vous ne réglez que la '
      + 'différence. Une baisse d\'effectif n\'est pas remboursée.',
  },
  {
    // ⚠️ PRÉCISÉE LE 13/09/2026. L'ancienne disait « paramétrables selon la
    //    législation de chaque pays » — vrai du mécanisme, faux de l'état : seul
    //    le TOGO a son référentiel complet. Les 18 autres sont proposés avec un
    //    référentiel incomplet, l'écran les affiche en anomalie, et le garde de la
    //    migration 044 refuse toute nouvelle mise à `actif`.
    //    ➡️ La réponse dit désormais ce qui EST servi (« Le Togo est en service »)
    //       et renvoie le délai des autres pays au devis, au lieu de laisser croire
    //       qu'un espace camerounais s'ouvre au même rythme qu'un togolais.
    q: 'La solution fonctionne-t-elle dans mon pays ?',
    r: 'GSS-360 est conçu pour la zone OHADA — Togo, Côte d\'Ivoire, Sénégal, Cameroun, Bénin et les autres pays membres. Chaque pays a son référentiel : convention collective, charges sociales et barèmes fiscaux, chacun avec la date d\'effet du texte qui le fonde. Le Togo est en service. Pour les autres pays, votre référentiel national est établi à l\'ouverture de votre espace, et le délai de mise en service figure dans votre devis.',
  },
  {
    // ⚠️ RÉÉCRITE LE 13/09/2026. L'ancienne promettait « vous recevez une
    //    notification automatique dès que vous approchez de la limite » et un
    //    « upgrade en un clic ». Vérifié : l'ordonnanceur de notifications ne
    //    surveille AUCUN seuil d'effectif (il remonte des échéances de paiement et
    //    des postes vacants), et aucun écran ne lit `effectif_min`/`effectif_max`.
    //    `horsBornes()` et `offrePourEffectif()` existent dans `grilleOffres.js`,
    //    sont exportées, et ne sont appelées NULLE PART.
    //    ⓘ CE QUE LE CODE FAIT VRAIMENT, et que la réponse décrit : il facture
    //      l'offre STOCKÉE sur l'abonnement, au tarif par agent de cette offre,
    //      quel que soit l'effectif. Rien ne bloque, rien ne bascule.
    q: 'Que se passe-t-il si je dépasse ma tranche d\'agents ?',
    r: 'Rien ne se passe automatiquement : votre facture reste celle de votre pack. Le passage à la tranche supérieure se fait à votre demande et prend effet à la période de facturation suivante.',
  },
];

export default function FaqPage() {
  const [openFaq, setOpenFaq] = useState(null);

  /* 🔴 CETTE PAGE POSAIT SON PROPRE TITRE — RETIRÉ LE 14/10/2026, même motif
   *    que `QuiSommesNous` : une seconde source, qui écrasait celle du
   *    pré-rendu à l'hydratation. Le titre vient de `src/seo/pages.js`, et son
   *    contenu y est repris (« logiciel de sécurité privée OHADA »). */

  return (
    <div className="vt">
      <VitrineNav />

      {/* Hero */}
      <section className="vt-faq-hero">
        <h1 className="vt-faq-hero-title">Questions fréquentes</h1>
        <p className="vt-faq-hero-sub">Tout ce que vous devez savoir avant de démarrer.</p>
      </section>

      {/* FAQ accordion */}
      <section className="vt-faq">
        <div className="vt-faq-list">
          {FAQ_ITEMS.map((item, i) => (
            <div key={i} className={`vt-faq-item${openFaq === i ? ' vt-faq-item--open' : ''}`}>
              <button
                type="button"
                className="vt-faq-question"
                onClick={() => setOpenFaq(openFaq === i ? null : i)}
                aria-expanded={openFaq === i}
              >
                <span>{item.q}</span>
                <span className="vt-faq-icon">{openFaq === i ? '−' : '+'}</span>
              </button>
              <div className="vt-faq-answer-wrap" style={{ maxHeight: openFaq === i ? '300px' : '0' }}>
                <p className="vt-faq-answer">{item.r}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Footer */}
      <footer className="vt-footer">
        <div className="vt-footer-inner">
          <div>
            <div className="vt-footer-name-row">
              {/* ⚠️ Pastille claire : le PNG est OPAQUE quasi blanc (RGBA 253,253,253,255
                  mesuré), le pied de page est en #16161C. Sans fond clair, un rectangle
                  lumineux. La ligne « Gladiator Security Systems » est retirée : le logo
                  porte déjà son wordmark, elle l'affichait deux fois à 12 px d'intervalle.
                  Elle survit dans l'alt, seul endroit où elle manquerait à un lecteur d'écran. */}
              <span className="vt-footer-pastille">
                <img
                  src="/logo-gladiator.png"
                  alt="Gladiator Security Systems, éditeur de GSS-360"
                  className="vt-footer-logo"
                  width="292"
                  height="234"
                  loading="lazy"
                />
              </span>
              <div>
                <div className="vt-footer-tagline">Éditeur de GSS-360, intégrateur de systèmes de sécurité</div>
              </div>
            </div>
            <div className="vt-footer-legal">
              RCCM TG-LFW-01-2024-B13-00449 · NIF 1001930788<br />
              Tokoin-Wuiti, Rue Air-Burkina, Lomé
            </div>
          </div>
          <div>
            <div className="vt-footer-col-title">Contact</div>
            <div className="vt-footer-contact">
              +228 92 53 15 14<br />+228 22 61 09 61
            </div>
            <a href="https://wa.me/22890054083" target="_blank" rel="noopener noreferrer" className="vt-footer-wa">
              <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
              WhatsApp : +228 90 05 40 83
            </a>
          </div>
          <div>
            <div className="vt-footer-col-title">Liens</div>
            <div className="vt-footer-links">
              <a href="/mentions-legales" className="vt-footer-link">Mentions légales</a>
              <a href="/confidentialite" className="vt-footer-link">Confidentialité</a>
              <a href="/faq" className="vt-footer-link">FAQ</a>
              <a href="/login" className="vt-footer-link">Se connecter</a>
            </div>
          </div>
        </div>
        <div className="vt-footer-copy">
          © 2026 Gladiator Security Systems. Tous droits réservés.
        </div>
      </footer>

      {/* WhatsApp flottant */}
      <a
        href="https://wa.me/22890054083?text=Bonjour%2C%20je%20souhaite%20en%20savoir%20plus%20sur%20GSS-360."
        target="_blank"
        rel="noopener noreferrer"
        className="vt-whatsapp"
        title="Nous écrire sur WhatsApp"
      >
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
        </svg>
      </a>
    </div>
  );
}
